var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-clamp"},[_c('div',{staticClass:"text",style:({height: _vm.height})},[(_vm.isVisible)?_c('span',{staticClass:"btn",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.isExpand ? '收起' : '... 展开'))]):_vm._e(),_c('div',{ref:"textRef",style:(_vm.commonStyle)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }